import React, { useCallback, useMemo, useState } from 'react';
import { Visibility } from 'semantic-ui-react';
import { Background, Description, DivRelative, SubTitle } from '../../components/layouts';
import { buildImageURL, getTrack, pureTrans } from '../../helpers';
import './style.scss';

const track = getTrack({ block: 19 });

const IMAGES = {
  d: {
    i1: buildImageURL('/ltm-d-0.jpg'),
    i2: buildImageURL('/ltm-d-1.jpg')
  },
  m: {
    i1: buildImageURL('/ltm-m-0.jpg'),
    i2: buildImageURL('/ltm-m-1.jpg')
  }
};

export function LTM({ mobile = false }) {
  const [progress, setProgress] = useState(0);
  const { a1, a2 } = useMemo(() => {
    return {
      a1: pureTrans(progress, [0, 0.5], [1, 0], 3),
      a2: pureTrans(progress, [0, 0.5], [0, 1], 3)
    };
  }, [progress]);

  const handleUpdate = useCallback(
    (e, { calculations: { percentagePassed } }) => {
      setProgress(percentagePassed);
    },
    [setProgress]
  );

  return (
    <Visibility fireOnMount offset={[-1000, 0]} onUpdate={handleUpdate} className="page-section section-ltm inverted" data-track={track}>
      <div className="sticky-content">
        <DivRelative>
          {!mobile && <Background active src={IMAGES.d.i1} opacity={a1} />}
          {!mobile && <Background active src={IMAGES.d.i2} opacity={a2} />}
          {mobile && <Background active src={IMAGES.m.i1} opacity={a1} />}
          {mobile && <Background active src={IMAGES.m.i2} opacity={a2} />}
          <div className="section-content left">
            <SubTitle>
              LTM阳光屏
              <br />
              无论明暗，始终好看
            </SubTitle>
            <Description>vivo 联合三星研发的 LTM 阳光屏，采用 HDR 10+ 技术和 E3 发光材料，屏幕在强光下也依旧看得清晰舒适。</Description>
          </div>
        </DivRelative>
      </div>
    </Visibility>
  );
}
